import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import { useTranslate } from "ra-core";
import { Printer } from "lucide-react";

import { Button } from "@/components/ui/button";
import { printLabels, type LabelContent } from "./labelSheet";
import { useLabelFormat } from "./racketHooks";

// Code 128 of a racket code, as an SVG
export const RacketBarcode = ({
  code,
  height = 40,
}: {
  code: string;
  height?: number;
}) => {
  const ref = useRef<SVGSVGElement>(null);
  useEffect(() => {
    if (!ref.current) return;
    JsBarcode(ref.current, code, {
      format: "CODE128",
      height,
      margin: 0,
      fontSize: 14,
      displayValue: true,
    });
  }, [code, height]);
  return <svg ref={ref} role="img" aria-label={code} />;
};

// The label of one racket, in the first cell of a sheet; several labels on
// one sheet from the rackets page (PrintLabelsDialog)
export const PrintLabelButton = ({ code, model }: LabelContent) => {
  const translate = useTranslate();
  const format = useLabelFormat();
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={() => printLabels([{ code, model }], format)}
    >
      <Printer className="size-4" />
      {translate("tenax.rackets.print_label")}
    </Button>
  );
};
